import React from 'react';
import { Row, Col, Card, Statistic, Progress } from 'antd';
import {
  CheckCircleOutlined,
  SyncOutlined,
  BugOutlined,
  StopOutlined,
  ClockCircleOutlined,
} from '@ant-design/icons';
import type { StatsData } from '../../../services/devApi';

interface StatsCardsProps {
  stats: StatsData | null;
  loading: boolean;
  onStatusClick: (status: string) => void;
}

const STATUS_CARDS = [
  { key: 'done', label: '已完成', color: '#52c41a', icon: <CheckCircleOutlined /> },
  { key: 'wip', label: '進行中', color: '#1677ff', icon: <SyncOutlined /> },
  { key: 'bug', label: '有 Bug', color: '#ff4d4f', icon: <BugOutlined /> },
  { key: 'blocked', label: '已阻塞', color: '#faad14', icon: <StopOutlined /> },
  { key: 'notStarted', label: '未開始', color: '#8c8c8c', icon: <ClockCircleOutlined /> },
] as const;

function getCompletionColor(rate: number): string {
  if (rate > 75) return '#52c41a';
  if (rate >= 25) return '#1677ff';
  return '#ff4d4f';
}

const StatsCards: React.FC<StatsCardsProps> = ({ stats, loading, onStatusClick }) => {
  const moduleStats = stats?.modules;
  const completionPercent = moduleStats
    ? Math.round(moduleStats.completionRate * 100)
    : 0;

  return (
    <Row gutter={[16, 16]}>
      {STATUS_CARDS.map((card) => {
        const value = moduleStats
          ? moduleStats[card.key as keyof typeof moduleStats] as number
          : 0;

        return (
          <Col xs={12} sm={8} md={4} key={card.key}>
            <Card
              hoverable
              loading={loading}
              className="text-center cursor-pointer"
              onClick={() => onStatusClick(card.key === 'notStarted' ? '--' : card.key)}
            >
              <Statistic
                title={card.label}
                value={value}
                prefix={React.cloneElement(card.icon, { style: { color: card.color } })}
                valueStyle={{ color: card.color }}
              />
            </Card>
          </Col>
        );
      })}
      <Col xs={12} sm={8} md={4}>
        <Card loading={loading} className="text-center">
          <div className="mb-2 text-gray-500">完成率</div>
          <Progress
            type="circle"
            percent={completionPercent}
            size={60}
            strokeColor={getCompletionColor(completionPercent)}
          />
          {moduleStats && (
            <div className="mt-2 text-xs text-gray-400">
              {moduleStats.done} / {moduleStats.total}
            </div>
          )}
        </Card>
      </Col>
    </Row>
  );
};

export default StatsCards;
